import { X } from 'lucide-react';

const Header = () => {
  return (
    <>
      {/* Header Notice */}
      <div className="bg-gray-900 border-b border-gray-800 px-6 py-2 text-xs text-gray-300 flex items-center justify-between">
        <p>
          All accounts offered are demo accounts with simulated funds. Trading occurs in a simulated environment. See FAQs for details.
        </p>
        <button className="text-gray-400 hover:text-white">
          <X size={16} />
        </button>
      </div>

      {/* Navigation */}
      <nav className="border-b border-gray-800 px-8" style={{ backgroundColor: '#101925' }}>
        <div className="max-w-7xl mx-auto flex items-center justify-start">
            <div className="flex items-center gap-3">
              <img src="/logo-bgremoved.png" alt="NEXXO FUNDED" className="h-16 brightness-110 contrast-110 saturate-110 hover:brightness-125 transition-all duration-300 rounded-lg" />
            </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
